import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import Typography from '@classify/react-core-components/Typography';
import Stack from '@classify/react-core-components/Stack';
import { translate } from '@openclassrooms/translations';
import { styled } from '@classify/react-core-components/styles';
import WbIncandescentIcon from '@mui/icons-material/WbIncandescent';
import learningOutcomesIllustration from '../images/learningOutcomes.svg';
import { useCourseContext } from '../../_contexts/CourseContext';
const ILLUSTRATION_SIZE = 200;
const RootStack = styled(Stack)(() => ({
  flexDirection: 'column'
}));
const StyledTitle = styled(Typography)(({
  theme
}) => ({
  width: '100%',
  paddingBottom: theme.spacing(1),
  borderBottom: `1px solid ${theme.palette.divider}`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(100% - (${theme.spacing(4)} + ${ILLUSTRATION_SIZE}px))`
  }
}));
const ContentStack = styled(Stack)(({
  theme
}) => ({
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    columnGap: theme.spacing(2),
    paddingTop: theme.spacing(3)
  }
}));
const ListStack = styled(Stack)(({
  theme
}) => ({
  width: '100%',
  flexDirection: 'column',
  margin: theme.spacing(1, 0, 2),
  padding: 0,
  listStyle: 'none',
  [theme.breakpoints.up('sm')]: {
    width: '65%',
    margin: 0
  }
}));
const StyledListItem = styled(ListItem)({
  alignItems: 'flex-start',
  paddingLeft: 0
});
const StyledListItemIcon = styled(ListItemIcon)(({
  theme,
  color
}) => ({
  border: '1px solid',
  borderColor: color,
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  boxSizing: 'border-box',
  marginRight: theme.spacing(2),
  width: 32,
  minWidth: 32,
  height: 32
}));
const LearningOutcomesImage = styled(Image)({
  width: ILLUSTRATION_SIZE,
  minWidth: ILLUSTRATION_SIZE,
  height: ILLUSTRATION_SIZE
});
const LearningOutcomes = () => {
  const $ = _c(13);
  const {
    course,
    learningOutcomes: t0
  } = useCourseContext();
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const learningOutcomes = t1;
  const {
    categoryColor
  } = course;
  if (learningOutcomes.length === 0) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <StyledTitle variant="h3" component="h2">{translate("course.overview.skills.title")}</StyledTitle>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== categoryColor || $[4] !== learningOutcomes) {
    let t4;
    if ($[6] !== categoryColor) {
      t4 = learningOutcome => <StyledListItem key={learningOutcome.id}><StyledListItemIcon color={categoryColor}><WbIncandescentIcon sx={{
            color: categoryColor,
            width: "20px",
            height: "20px",
            transform: "rotate(180deg)"
          }} /></StyledListItemIcon><ListItemText primary={learningOutcome.name} /></StyledListItem>;
      $[6] = categoryColor;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t3 = learningOutcomes.map(t4);
    $[3] = categoryColor;
    $[4] = learningOutcomes;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <ListStack component="ul">{t3}</ListStack>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <LearningOutcomesImage alt="" src={learningOutcomesIllustration} />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4) {
    t6 = <RootStack>{t2}<ContentStack>{t4}{t5}</ContentStack></RootStack>;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default LearningOutcomes;